module.exports = __webpack_public_path__ + "fonts/Inter-200-latin17.5eb4a77.woff2";